<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }

    .actived {
        color: #20bf64;
    }
</style>
<template>
    <div style="padding: 20px 0">
        <div style="padding: 0px 0">
            <div>
                <div style="display: flex; align-items: center">
                    <div style="padding: 20px; font-size: 24px; font-weight: bold">请选择{{ options.name }}</div>
                    <div style="padding: 10px">
                        <Input v-model="query.keywords" icon="ios-search" :placeholder="options.placeholder || '输入名称/编码查询...'" style="width: 240px" @on-enter="keywordsChanged"> </Input>
                        <!-- <Button type="primary" @click="showConditions">按条件筛选</Button> -->
                        <Tag v-if="usedKeywords" closable @on-close="clearKeywords" style="height: 32px; line-height: 32px; margin: 0"> 搜索：{{ usedKeywords }}</Tag>
                        <Tag
                            v-if="query.selections"
                            closable
                            @on-close="
                                query.selections = null
                                loadData()
                            "
                            style="height: 32px; line-height: 32px; margin: 0">
                            仅查看包含在 <span style="color: #20bf64">{{ query.selections.length }}</span> 个已选项中的内容</Tag
                        >
                    </div>
                </div>
                <div v-if="results.length">
                    <Table ref="sheet" :columns="columns" :loading="loading" :row-class-name="getRowClass" :data="results" @on-select="itemSelected" @on-row-click="rowSelected" @on-select-cancel="itemSelectedCancel" @on-select-all="allSelected" @on-select-all-cancel="allSelectedCancel"></Table>
                    <div class="jcsb">
                        <div>
                            <div style="padding: 10px 20px; display: flex; align-items: center" v-if="selections.length || results.length">
                                已选<span style="color: #20bf64; margin: 0 4px">{{ selections.length }}</span
                                >项
                                <div v-if="selections.length" style="display: flex">
                                    <div @click="showSelections" style="color: #20bf64; margin-left: 10px" class="hover">查看</div>
                                    <div @click="clearSelections" style="color: #20bf64; margin-left: 10px" class="hover">取消选择</div>
                                </div>
                                <template v-if="options.importable">
                                    <a class="hover" style="color: #20bf64; margin-left: 20px" @click="exportSelections">导出选项</a>
                                    <Upload ref="uploader" :data="uploadConfig" :show-upload-list="false" :on-success="fileUploadSuccess" :on-progress="fileProgress" multiple action="//upload.qiniup.com/">
                                        <div @click="refreshUploadToken">
                                            <a class="hover" style="color: #20bf64; margin-left: 20px">导入选项</a>
                                        </div>
                                    </Upload>
                                </template>
                            </div>
                        </div>
                        <Page size="small" v-if="!nopage" placement="top" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" @on-page-size-change="pageSizeChanged" show-total show-sizer :page-size-opts="[10, 20, 50, 100, 200]" style="padding: 16px"></Page>
                    </div>
                </div>
                <div v-if="!results.length" class="center" style="color: #aaa; min-height: 200px">暂无数据</div>
            </div>
        </div>
        <div class="foot jcsb" style="padding: 0 20px">
            <div>
                <div v-if="!options.multi && selections.length > 1" style="color: red">只能选择1项</div>
                <div v-else-if="options.max && selections.length > options.max" style="color: red">只能选择{{ options.max }}项</div>
            </div>
            <div class="center">
                <Button @click="cancel" style="margin-right: 10px">取消</Button>
                <Button v-if="(!options.multi && selections.length != 1) || (options.max && selections.length > options.max)" disabled type="primary">确定</Button>
                <Button v-else type="primary" @click="confirm">确定</Button>
            </div>
        </div>
    </div>
</template>
<script>
    import { AmountDecimal } from '@/utils/price'

    export default {
        props: {
            options: {
                type: Object,
                default: {},
            },
            nopage: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                session: this.$store.session,
                loading: false,
                query: {
                    keywords: '',
                    init: true,
                },
                usedKeywords: '',
                page: {
                    current: 1,
                    size: 10,
                },
                total: 0,
                columns: [{ type: 'selection', align: 'center', width: 60 }, ...this.options.columns],
                results: [],
                selections: [],
                uploadConfig: null,
                importErrorModal: false,
                importErrors: [],
                importedItems: [],
            }
        },
        mounted() {
            if (this.options.all) {
                this.page.size = 99999999
            } else {
                this.page.size = Number(sessionStorage[`query:${this.options.datatype}.pagesize`]) || 5
            }
            if (this.options.current) {
                if (this.options.multi) {
                    this.selections = this.options.current.map((item) => {
                        return item
                    }) //使用map中断引用传递
                } else {
                    this.selections = [this.options.current]
                }
                if (this.options.disablecurrent) {
                    for (let item of this.selections) {
                        item._disabled = true
                    }
                }
            }
            this.loadData()
        },
        methods: {
            exportSelections() {
                this.$refs.sheet.exportCsv({
                    filename: '数据导出_' + this.selections.length + '条_' + new Date().getTime(),
                    columns: this.options.importColumns,
                    data: this.selections,
                })
            },
            async toImport({ url }) {
                console.log('url',url)
                this.loading = true
                let loadurl = this.options.loadurl || '/web/main/selector/load'
                let res = await this.$api.post(loadurl, {
                    datatype: this.options.datatype,
                    query: this.query,
                    fields: this.options.fields,
                    loadSelectionFromFile: url,
                    importColumns: this.options.importColumns,
                })
                this.loading = false
                let { items, errors } = res.data
                this.importedItems = items
                if (errors && errors.length) {
                    this.importErrors = errors
                    this.importErrorModal = true
                    return
                }

                this.importErrors = []
                this.doImport()
            },

            async doImport() {
                this.importErrorModal = false
                for (let item of this.importedItems) {
                    let formItem = this.selections.findOne({ _id: item._id })
                    if (!formItem) {
                        this.selections.push(item)
                    }
                }
                this.resultUpdate()
            },
            fileUploadSuccess(res, file) {
                console.log('fileUploadSuccess', res, file)
                file.url = '//igyl.weizhilian.com/' + res.key
                this.loading = false
                this.toImport({ url: file.url })
            },
            fileProgress(res, file) {
                if (!file) {
                    return
                }
                this.detailModal = true
                this.loading = true
            },
            refreshUploadToken() {
                let that = this
                that.loadUploadToken(function (token) {
                    that.uploadConfig = {
                        token: token,
                    }
                })
            },
            clearKeywords() {
                this.query.keywords = ''
                this.usedKeywords = ''
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            pageSizeChanged(value) {
                this.page.size = value
                sessionStorage[`query:${this.options.datatype}.pagesize`] = value
                if (this.page.current == 1) this.loadData()
            },
            loadData() {
                this.loading = true
                if (this.options.query) {
                    for (let key of Object.keys(this.options.query)) {
                        this.query[key] = this.options.query[key]
                    }
                }
                let loadurl = this.options.loadurl || '/web/main/selector/load'
                this.$api
                    .post(loadurl, {
                        datatype: this.options.datatype,
                        query: this.query,
                        page: this.page,
                        fields: this.options.fields,
                    })
                    .then(
                        (res) => {
                            this.loading = false
                            if (this.query.init) {
                                this.query.init = false
                            }
                            this.total = res.data.total
                            this.usedKeywords = this.query.keywords
                            let results = res.data.results
                            for (let result of results) {
                                let item = this.selections.findOne({ _id: result._id })
                                if (item) {
                                    result._checked = true
                                    if (item._disabled) {
                                        result._disabled = true
                                    }
                                }
                                for (let c of this.columns) {
                                    if (c.fix) {
                                        result[c.key] = AmountDecimal(result[c.key], c.fix)
                                    }
                                }
                            }
                            this.results = results
                            if (this.options.disableItem) {
                                this.options.disableItem(this, this.results, this.selections)
                            }
                        },
                        () => {
                            this.loading = false
                        },
                    )
            },
            search() {
                this.loadData()
            },
            cancel() {
                this.$emit('cancel')
            },
            confirm() {
                for (let s of this.selections) {
                    delete s._checked
                    delete s._disabled
                }
                let value
                if (this.options.multi) {
                    value = this.selections
                } else {
                    value = this.selections[0]
                }
                if (this.options.fields) {
                    value = this.simple(value, this.options.fields)
                }
                this.$emit('confirm', value)
            },

            showSelections() {
                this.query.selections = this.selections.map((item) => {
                    return { _id: item._id }
                })
                this.page.current = 1
                this.loadData()
            },
            clearSelections() {
                this.selections = this.selections.filter((o) => {
                    return o._disabled
                })
                let results = []
                for (let item of this.results) {
                    if (!item._disabled) {
                        item._checked = false
                    }
                    results.push(item)
                }
                this.results = results
                if (this.options.disableItem) {
                    this.options.disableItem(this, this.results, this.selections)
                }
            },
            allSelected(items) {
                if (this.options.disableItem) {
                    //如果存在选择冲突项目，需要一个一个选择以排除冲突
                    for (let item of this.results) {
                        let current = this.selections.findOne({ _id: item._id })
                        if (!current && !item._disabled) {
                            this.itemSelected({}, item)
                        }
                    }
                } else {
                    for (let item of items) {
                        if (!this.selections.findOne({ _id: item._id })) {
                            if (!item._disabled) {
                                this.selections.push(item)
                            }
                        }
                    }
                }
            },
            allSelectedCancel() {
                if (this.options.disableItem) {
                    for (let item of this.results) {
                        this.itemSelectedCancel({}, item)
                    }
                } else {
                    for (let item of this.results) {
                        if (!item._disabled) {
                            this.selections.remove({ _id: item._id })
                        }
                    }
                }
            },
            rowSelected(item) {
                if (item._disabled) return
                let current = this.selections.findOne({ _id: item._id })
                if (current) {
                    this.itemSelectedCancel({}, item)
                } else {
                    this.itemSelected({}, item)
                }
            },
            itemSelected(_, item) {
                if (this.options.multi) {
                    this.selections.push(item)
                } else {
                    this.selections = [item]
                }
                this.resultUpdate()
            },
            itemSelectedCancel(_, item) {
                this.selections.remove({ _id: item._id })
                this.resultUpdate()
            },
            resultUpdate() {
                let results = []
                for (let result of this.results) {
                    if (!result._disabled) {
                        let current = this.selections.findOne({ _id: result._id })
                        if (current) {
                            result._checked = true
                        } else {
                            result._checked = false
                        }
                    }
                    results.push(result)
                }
                this.results = results
                if (this.options.disableItem) {
                    this.options.disableItem(this, this.results, this.selections)
                }
            },
            getRowClass() {
                return 'hover'
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/common/DataSelector.vue?c17c0e12